import {
	Button,
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	RootDialogProps,
} from "@dune/ui";
import { Loader2 } from "lucide-react";
import { FormProvider } from "react-hook-form";
import { ContactForm } from "./ContactForm";
import { useUpdateContactForm } from "./useUpdateContactForm";

export const UpdateContactDialog = (
	props: RootDialogProps & { contactToUpdateId: number },
) => {
	const { onSubmit, isLoadingContact, isPendingUpdate, formMethods } =
		useUpdateContactForm(props.contactToUpdateId, () => {
			props.onOpenChange?.(false);
		});

	const {
		formState: { isDirty },
	} = formMethods;

	if (isLoadingContact) {
		return <Loader2 className="animate-spin" />;
	}

	return (
		<Dialog {...props}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Modifier un contact</DialogTitle>
				</DialogHeader>
				<FormProvider {...formMethods}>
					<ContactForm mode="update" />
				</FormProvider>
				<DialogFooter>
					<Button onClick={() => props.onOpenChange?.(false)}>Annuler</Button>
					<Button
						onClick={onSubmit()}
						isLoading={isPendingUpdate}
						disabled={!isDirty}
					>
						Valider
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
